import {
  trackUmamiEvent,
  identifyUmamiSession,
} from '@jaseeey/vue-umami-plugin';

/**
 * Configurações do Umami Analytics
 */
export const umamiConfig = {
  websiteID: '4db25f24-a292-4593-9983-0c99dc3056d3',
  scriptSrc: 'https://analytics.fornecedoresconfeccao.com.br/script.js',
  allowLocalhost: true,
};

/**
 * Hook personalizado para utilização do Umami Analytics
 */
export function useAnalytics() {
  /**
   * Rastreia um evento personalizado
   * @param {string} eventName - Nome do evento
   * @param {Object} eventParams - Parâmetros adicionais do evento
   */
  const trackEvent = (eventName, eventParams = {}) => {
    trackUmamiEvent(eventName, eventParams);
  };

  /**
   * Identifica uma sessão do usuário
   * @param {Object} userData - Dados do usuário para identificação
   */
  const identifyUser = (userData = {}) => {
    identifyUmamiSession(userData);
  };

  return {
    trackEvent,
    identifyUser,
  };
}

export default {
  umamiConfig,
  useAnalytics,
};
